import {
    FETCH_START,
    USER_SIGNED_IN,
    USER_NOT_AUTHENTICATED,
    OPEN_SIGNIN_MODAL,
    OPEN_SIGNUP_MODAL,
    OPEN_PASSWORD_RECOVERY_MODAL,
    CLOSE_SIGNIN_MODAL,
    CLOSE_SIGNUP_MODAL,
    CLOSE_PASSWORD_RECOVERY_MODAL,
    PASSWORD_RECOVERY_FETCHED
} from './accountConstants'

const INITIAL_STATE = {
    loading: false,
    user: null,
    message: null,
    signInModalIsOpen: false,
    signUpModalIsOpen: false,
    passwordRecoveryModalIsOpen: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true, message: null };
        
        case USER_SIGNED_IN:
            return { 
                ...state, 
                loading: false, 
                user: action.payload, 
                signInModalIsOpen: false, 
                signUpModalIsOpen: false, 
                passwordRecoveryModalIsOpen: false,
                message: null
            };

        case USER_NOT_AUTHENTICATED:
            return { ...state, loading: false, user: null, message: action.payload };

        case OPEN_SIGNIN_MODAL:
            return { 
                ...state, 
                signInModalIsOpen: true, 
                signUpModalIsOpen: false, 
                passwordRecoveryModalIsOpen: false,
                message: null
            };

        case OPEN_SIGNUP_MODAL:
            return { 
                ...state, 
                signInModalIsOpen: false, 
                signUpModalIsOpen: true, 
                passwordRecoveryModalIsOpen: false,
                message: null
            };

        case OPEN_PASSWORD_RECOVERY_MODAL:
            return { 
                ...state, 
                signInModalIsOpen: false, 
                signUpModalIsOpen: false, 
                passwordRecoveryModalIsOpen: true,
                message: null
            };

        case CLOSE_SIGNIN_MODAL:
            return { ...state, signInModalIsOpen: false, message: null };

        case CLOSE_SIGNUP_MODAL:
            return { ...state, signUpModalIsOpen: false, message: null };

        case CLOSE_PASSWORD_RECOVERY_MODAL:
            return { ...state, passwordRecoveryModalIsOpen: false, message: null }

        case PASSWORD_RECOVERY_FETCHED: 
            return { ...state, loading: false, message: action.payload }
        default:
            return state
    }
}
